export const name = '@lifi/widget'
export const version = '3.27.2'
